import React from 'react'
import { NumericFormat } from 'react-number-format';

function CurrencyMask({ onChange, ...rest }) {
    return (
        <NumericFormat
            {...rest}
            prefix={"$"}
            fixedDecimalScale={true}
            thousandSeparator={true}
            decimalScale={2}
            className="form-control"
            onValueChange={(value) => onChange(value.floatValue)}
        />
    )
}
export default CurrencyMask;